export function deriveTenantSlugFromHost(host: string): string | null {
  if (!host) return null
  const lower = host.trim().toLowerCase()
  if (lower.length === 0) return null
  const withoutPort = lower.startsWith('[')
    ? lower.split(']')[0]?.slice(1) ?? ''
    : lower.split(':')[0] ?? ''
  if (withoutPort.length === 0) return null
  if (withoutPort === 'localhost') return 'localhost'
  const labels = withoutPort.split('.').filter(Boolean)
  if (labels.length >= 3) {
    return labels[0] ?? null
  }
  if (labels.length === 2) {
    return labels[0] ?? null
  }
  return null
}
